import script from "./heroSlideBox.vue?vue&type=script&setup=true&lang=js"
export * from "./heroSlideBox.vue?vue&type=script&setup=true&lang=js"

import "./heroSlideBox.vue?vue&type=style&index=0&id=1af60f2c&scoped=true&lang=css"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af60f2c"]])

export default __exports__